import { useEffect, useState } from 'react';
import { EditOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {
  Table,
  Button,
  Form,
  notification,
  Tabs,
  Space,
  Checkbox,
  Row,
  Radio,
} from 'antd';
import axios from 'axios';
import type { TabsProps } from 'antd';
import EditClientDeclensions from '../EditClientDeclensions';
import api from '@modules/Quotation/services/saveQuotation';
import { useImmerReducer } from 'use-immer';
import CustomLoader from '@components/UI/CustomLoader/CustomLoader';
import useAuth from '@hooks/useAuth';

type Action = {
  type: 'getContractorData' | 'loading';
  payload?: any;
};
interface State {
  dataList: any;
  isLoad: boolean;
}
const initialState: State = {
  dataList: [],
  isLoad: false,
};
const reducer = (draft = initialState, action: Action) => {
  switch (action.type) {
    case 'getContractorData': {
      draft.dataList = action.payload;
      break;
    }
    case 'loading': {
      draft.isLoad = action.payload;
      break;
    }
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
};
type TablePaginationPosition =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

function ClientAddAttr({ subjisn, addAttrData }) {
  const auth = useAuth();
  const [editingKey, setEditingKey] = useState<any>();
  const [state, dispatch] = useImmerReducer(reducer, initialState);
  const [clientAttrForm] = Form.useForm();
  const { dataList, isLoad } = state;

  const saveAttr = async (val, attr_isn) => {
    try {
      const { data } = await api.attributeSave({
        agr_attributes: [
          {
            attr_isn: attr_isn,
            class_isn: 220567,
            val_n: val.target.value,
            obj_isn: subjisn,
            user_isn: auth.user?.data?.user_info?.foreign_id,
          },
        ],
      });
    } catch (error) {
      let message;

      if (axios.isAxiosError(error) && error.response) {
        message = error.response.data.message;
      } else {
        message = String(error);
      }

      notification.info({
        message: 'Ошибка',
        description: message,
      });
    }
  };
  useEffect(() => {
    if (addAttrData) {
      dispatch({ type: 'getContractorData', payload: addAttrData });
      addAttrData.map((item) => {
        clientAttrForm.setFieldValue(Number(item.attr_isn), item.val_n === '1');
      });
    }
  }, [addAttrData]);

  return (
    <CustomLoader spinning={isLoad}>
      <Form layout="horizontal" form={clientAttrForm}>
        <Form.Item
          name="2722581"
          label=" Более 25% долей участия в уставном капитале/владение более 25% размещенных и голосующих акций"
        >
          <Radio.Group
            onChange={(val) => saveAttr(val, 2722581)}
            options={[
              { label: 'Да', value: true },
              { label: 'Нет', value: false },
            ]}
            optionType="button"
            buttonStyle="solid"
          />
        </Form.Item>
        <Form.Item
          name="2722601"
          label=" Лицо, в интересах которого совершаются операции с деньгами и (или) иным имуществом"
        >
          <Radio.Group
            onChange={(val) => saveAttr(val, 2722601)}
            options={[
              { label: 'Да', value: true },
              { label: 'Нет', value: false },
            ]}
            optionType="button"
            buttonStyle="solid"
          />
        </Form.Item>
        <Form.Item name="2722591" label="Осуществление контроля над клиентом">
          <Radio.Group
            onChange={(val) => saveAttr(val, 2722591)}
            options={[
              { label: 'Да', value: true },
              { label: 'Нет', value: false },
            ]}
            optionType="button"
            buttonStyle="solid"
          />
        </Form.Item>
      </Form>
    </CustomLoader>
  );
}
export default ClientAddAttr;
